import {UIConfig} from '../../../../shared-gen/Model/Devices/Config/UIConfig';
import { LanguageCode } from '../../../../shared-gen/Model/Localization/LanguageCode';

export class UIConfigFun {

    static createNew(): UIConfig {
        return {
            Language: LanguageCode.DE,
            CultureCode: 'de-DE',
            AppTheme: 'Blackboard',
            CartItemsCount: 1,
            Debug: false,
            FailedTime: 10,
            InactiveUserTime: 30,
            InactiveCancelTime: 60,
            Path: '',
            ServedTime: 10
        }
    }

}
